import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FilterListIcon from '@mui/icons-material/FilterList';

export interface SortOption {
  label: string;
  value: string;
}

interface DealsSortDropdownProps {
  options: SortOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const DealsSortDropdown: React.FC<DealsSortDropdownProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleOptionClick = (optionValue: string) => {
    // If clicking on the already selected option, deselect it
    if (value === optionValue) {
      onChange('none');
    } else {
      onChange(optionValue);
    }
    setOpen(false);
  };

  return (
    <div className="relative">
      <div
        onClick={() => setOpen(!open)}
        className={`${className} bg-white border border-stone-200 rounded-lg px-4 py-2.5 cursor-pointer flex items-center justify-between  gap-2`}
      >
        {value === 'none' && <FilterListIcon className="h-3 w-3 text-stone-500" />}
        <span className="text-xs font-semibold text-stone-900 ">
          {value === 'none'
            ? 'Sort By'
            : options.find((opt) => opt.value === value)?.label || 'Sort By'}
        </span>
        <KeyboardArrowDownIcon className="text-stone-500" />
      </div>

      {open && (
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white border border-stone-200 rounded-lg shadow-lg z-10 whitespace-nowrap w-fit">
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className="flex items-center px-4 py-2.5 hover:bg-stone-50 cursor-pointer"
            >
              <div className="mr-3">
                {value === option.value && value !== 'none' ? (
                  <span className="w-5 h-5 rounded-full border-2 border-gray-700 flex items-center justify-center bg-white">
                    <span className="w-2.5 h-2.5 rounded-full bg-gray-700 block"></span>
                  </span>
                ) : (
                  <span className="w-5 h-5 rounded-full border-2 border-gray-400 flex items-center justify-center bg-white"></span>
                )}
              </div>
              <span className="text-gray-700 font-medium text-sm">{option.label}</span>
            </div>
          ))}
        </div>
      )}

      {/* Click outside to close */}
      {open && <div className="fixed inset-0 z-0" onClick={() => setOpen(false)} />}
    </div>
  );
};

export default DealsSortDropdown;
